import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteAccidentIssueDocumentInput,
  DeleteAccidentIssueDocumentBulkResponse,
  MutationDeleteAccidentIssueDocumentBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteAccidentIssueDocument } from '@/features/AccidentHistory/api/queries/DeleteAccidentIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteAccidentIssueDocumentInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteAccidentIssueDocumentBulkResponse>;
}

// SearchAccidentIssue Service
export const { deleteAccidentIssueDocument, useDeleteAccidentIssueDocument } = ((): {
  deleteAccidentIssueDocument: ServiceMethod;
  useDeleteAccidentIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteAccidentIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteAccidentIssueDocumentInput[],
        options?: ConnectionOptions
      ): Promise<DeleteAccidentIssueDocumentBulkResponse> => {
        const args: MutationDeleteAccidentIssueDocumentBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteAccidentIssueDocumentBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteAccidentIssueDocumentBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteAccidentIssueDocument: fetch,
    useDeleteAccidentIssueDocument: useService,
  };
})();
